export { default } from "./SectionInfoTitle";